import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Download, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/neighbour-sale-logo.png" 
              alt="Neighbour's Sale" 
              className="h-10 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              className="bg-blue-600 hover:bg-blue-700"
              onClick={() => window.open('https://play.google.com/store', '_blank')}
            >
              <Download className="w-5 h-5 mr-2" />
              Download App
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-4 space-y-3">
            <Button
              className="w-full bg-blue-600 hover:bg-blue-700"
              onClick={() => {
                window.open('https://play.google.com/store', '_blank');
                setMobileMenuOpen(false);
              }}
            >
              <Download className="w-5 h-5 mr-2" />
              Download on Google Play
            </Button>
            <Button
              variant="outline"
              className="w-full"
              onClick={() => {
                window.open('https://apps.apple.com', '_blank');
                setMobileMenuOpen(false);
              }}
            >
              Download on App Store
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;